module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lenora Worth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lenora Worth writes for Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and a "), _c('I', [_vm._v("New York Times")]), _vm._v(", "), _c('I', [_vm._v("USA Today")]), _vm._v(", and "), _c('I', [_vm._v("PW")]), _vm._v(" bestselling author. She writes Southern stories set in places she loves such as Georgia, Texas,  Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wYzmYO/tc-custom/9781460342398.jpg?1726871225689",
      "alt": "This image is the cover for the book Deadly Holiday Reunion"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deadly Holiday Reunion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author Lenora Worth…"), _c('br'), _c('br'), _c('b', [_vm._v("A CHILD'S LIFE WAS IN JEOPARDY ")]), _c('br'), _c('br'), _vm._v("Texas Ranger Jake Cavanaugh will do anything to rescue his kidnapped daughter from the clutches of a killer. And that means turning to Ella Terrell—his high school sweetheart—for help. The former FBI agent is lucky to be alive after her own encounter with the vengeful madman. And now history seems to be repeating itself this holiday season. Ella needs time to sort through the past—yet time is a luxury they don't have. For the kidnapper is taunting them with misleading clues and a ticking clock. But Ella will bring Jake's child home at all costs—even at the risk of losing her heart and her life…."), _c('br'), _c('br'), _c('b', [_vm._v("From Love Inspired Suspense: Courage. Danger. Faith.")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0